import { useMediaQuery, useTheme } from "@mui/material";

const useDevice = () => {
    const theme = useTheme();
    const isMobileDevice = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isWebDevice = useMediaQuery(theme.breakpoints.up('md'));



    return {
        isWebDevice,
        isTablet,
        isMobileDevice,
    }
}

export default useDevice;